<template>
	<div class="switch-text-wrapper" :class="{'active': isActive, 'mobile': getMobileAppState}">
		<div class="text-icon-wrapper">
			<!-- Icon -->
			<app-icon v-if="icon" class="icon"/>
			<!-- Text -->
			<label>{{text}}</label>
			<slot></slot>
		</div>
		<!-- Switch -->
		<switch-generic :isActive="isActive" @clicked="emit('clicked', $event)"/>
	</div>
</template>

<script setup>
import SwitchGeneric from '@/components/generic/switch/Generic'

/* Vue */
import { computed, defineAsyncComponent } from 'vue'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* mapGetters */
const { getMobileAppState } = mapGetters()

/* Emmitters */
const emit = defineEmits(['clicked'])

/** props received
@icon {String} - icon name (it can include path if icon is inside some folder)
@text {String} - to display as toggle text
@isActive {Boolean} - prop to trigger isActive styles
@disabled {Boolean} - prop to apply disabled styles
*/
const props = defineProps({
	icon: String,
	text: String,
	isActive: Boolean,
	disabled: Boolean
})

/* Computed */
const appIcon = computed(() => {
	return defineAsyncComponent(() => import('@/assets/icons/' + props.icon + '.svg?inline'))
})
</script>

<style lang="scss" scoped>
.switch-text-wrapper {
	width: 100%;
	height: 32px;

	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
    gap: 8px;
    row-gap: 8px;

	.text-icon-wrapper {
		@include H5-Regular;
		color: var(--secondary-dark-3);

		display: flex;
		flex-wrap: wrap;
		gap: 8px;

		::first-letter {
			text-transform: uppercase;
		}

		svg.icon {
            :deep(.change-color-fill) {
                fill: var(--secondary-dark-2);
            }
        }
	}

	&.mobile {
		height: 40px;
	}

}
</style>
